export const GET_PUBLICATIONS_REQUEST = 'GET_PUBLICATIONS_REQUEST';
export const GET_PUBLICATIONS_SUCCESS = 'GET_PUBLICATIONS_SUCCESS';
export const GET_PUBLICATIONS_FAILURE = 'GET_PUBLICATIONS_FAILURE';

export const getPublications = ({ accessStatus }) => ({ type: GET_PUBLICATIONS_REQUEST, accessStatus });

export const getPublicationsSuccess = data => ({ type: GET_PUBLICATIONS_SUCCESS, data });

export const getPublicationsFailure = () => ({ type: GET_PUBLICATIONS_FAILURE });

export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE';

export const getCountries = () => ({ type: GET_COUNTRIES_REQUEST });

export const getCountriesSuccess = data => ({ type: GET_COUNTRIES_SUCCESS, data });

export const getCountriesFailure = () => ({ type: GET_COUNTRIES_FAILURE });

export const GET_DOCUMENTS_BY_PUBLICATION_REQUEST = 'GET_DOCUMENTS_BY_PUBLICATION_REQUEST';
export const GET_DOCUMENTS_BY_PUBLICATION_SUCCESS = 'GET_DOCUMENTS_BY_PUBLICATION_SUCCESS';
export const GET_DOCUMENTS_BY_PUBLICATION_FAILURE = 'GET_DOCUMENTS_BY_PUBLICATION_FAILURE';

export const getDocumentsByPublication = publicationId => ({ type: GET_DOCUMENTS_BY_PUBLICATION_REQUEST, publicationId });

export const getDocumentsByPublicationSuccess = data => ({ type: GET_DOCUMENTS_BY_PUBLICATION_SUCCESS, data });

export const getDocumentsByPublicationFailure = () => ({ type: GET_DOCUMENTS_BY_PUBLICATION_FAILURE });

export const GET_SECTIONS_BY_DOCUMENT_REQUEST = 'GET_SECTIONS_BY_DOCUMENT_REQUEST';
export const GET_SECTIONS_BY_DOCUMENT_SUCCESS = 'GET_SECTIONS_BY_DOCUMENT_SUCCESS';
export const GET_SECTIONS_BY_DOCUMENT_FAILURE = 'GET_SECTIONS_BY_DOCUMENT_FAILURE';

export const getSectionsByDocument = documentId => ({ type: GET_SECTIONS_BY_DOCUMENT_REQUEST, documentId });

export const getSectionsByDocumentSuccess = data => ({ type: GET_SECTIONS_BY_DOCUMENT_SUCCESS, data });

export const getSectionsByDocumentFailure = () => ({ type: GET_SECTIONS_BY_DOCUMENT_FAILURE });

export const GET_STATES_BY_COUNTRY_REQUEST = 'GET_STATES_BY_COUNTRY_REQUEST';
export const GET_STATES_BY_COUNTRY_SUCCESS = 'GET_STATES_BY_COUNTRY_SUCCESS';
export const GET_STATES_BY_COUNTRY_FAILURE = 'GET_STATES_BY_COUNTRY_FAILURE';

export const getStatesByCountry = countryCode => ({ type: GET_STATES_BY_COUNTRY_REQUEST, countryCode });

export const getStatesByCountrySuccess = data => ({ type: GET_STATES_BY_COUNTRY_SUCCESS, data });

export const getStatesByCountryFailure = () => ({ type: GET_STATES_BY_COUNTRY_FAILURE });

export const CHANGE_CURRICULUM_TYPE = 'CHANGE_CURRICULUM_TYPE';
export const changeCurriculumType = curriculumCode => ({ type: CHANGE_CURRICULUM_TYPE, curriculumCode });

export const CHANGE_COUNTRY = 'CHANGE_COUNTRY';
export const changeCountry = countryCode => ({ type: CHANGE_COUNTRY, countryCode });

export const CHANGE_STATE = 'CHANGE_STATE';
export const changeState = state => ({ type: CHANGE_STATE, state });

export const CHANGE_PUBLICATION = 'CHANGE_PUBLICATION';
export const changePublication = publicationId => ({ type: CHANGE_PUBLICATION, publicationId });

export const CHANGE_DOCUMENT = 'CHANGE_DOCUMENT';
export const changeDocument = documentId => ({ type: CHANGE_DOCUMENT, documentId });

export const CHANGE_SECTION = 'CHANGE_SECTION';
export const changeSection = sectionId => ({ type: CHANGE_SECTION, sectionId });

export const CHANGE_PRODUCT = 'CHANGE_PRODUCT';
export const changeProduct = productId => ({ type: CHANGE_PRODUCT, productId });

export const LOAD_SECTION_LIST = 'LOAD_SECTION_LIST';
export const loadSectionList = () => ({ type: LOAD_SECTION_LIST });

export const GET_SECTION_DETAIL_BY_ID_REQUEST = 'GET_SECTION_DETAIL_BY_ID_REQUEST';
export const GET_SECTION_DETAIL_BY_ID_SUCCESS = 'GET_SECTION_DETAIL_BY_ID_SUCCESS';
export const GET_SECTION_DETAIL_BY_ID_FAILURE = 'GET_SECTION_DETAIL_BY_ID_FAILURE';

export const getSectionDetails = sectionId => ({ type: GET_SECTION_DETAIL_BY_ID_REQUEST, sectionId });

export const getSectionDetailsSuccess = data => ({ type: GET_SECTION_DETAIL_BY_ID_SUCCESS, data });

export const getSectionDetailsFailure = () => ({ type: GET_SECTION_DETAIL_BY_ID_FAILURE });

export const UPDATE_TREE_DATA = 'UPDATE_TREE_DATA';
export const updateTreeData = () => ({ type: UPDATE_TREE_DATA });

export const REGISTER_MASTER_COURSE_REQUEST = 'REGISTER_MASTER_COURSE_REQUEST';
export const REGISTER_MASTER_COURSE_SUCCESS = 'REGISTER_MASTER_COURSE_SUCCESS';
export const REGISTER_MASTER_COURSE_FAILURE = 'REGISTER_MASTER_COURSE_FAILURE';

export const registerMasterCourse = (sectionId, increaseVersion) => ({ type: REGISTER_MASTER_COURSE_REQUEST, sectionId, increaseVersion });

export const registerMasterCourseSuccess = data => ({ type: REGISTER_MASTER_COURSE_SUCCESS, data });

export const registerMasterCourseFailure = () => ({ type: REGISTER_MASTER_COURSE_FAILURE });

export const UPDATE_PUBLICATIONS = 'UPDATE_PUBLICATIONS';

export const updatePublications = publications => ({ type: UPDATE_PUBLICATIONS, publications });



// WEBPACK FOOTER //
// ./app/containers/curriculum-list/actions.js